/*
 * @Date: 2020-08-11 19:24:21
 * @LastEditors: lingbinzzz
 * @LastEditTime: 2020-09-22 16:06:52
 * @FilePath: \pc-mall\src\constant\config.js
 */
export const config = {
  filterReservationDaily: '19:00-21:00',
  isShowFilterReservationDaily: false,
  // 现场
  BASE_URL: 'https://quanyu.xiqiaoshantour.com/api',
  TENANTID: '8742a570ac2a6a8cc142d3fc4d619d5f',
  MERCHID: '603f8986b04a4a7e844c0437e4876fb7',
  SUBDOMAIN: 'quanyu',
  SALESTATIONS: 's_official_website'
  // 测试
  // BASE_URL: 'http://192.168.1.65:8760',
  // TENANTID: 'd43276732898f7c7610184b90330379c',
  // MERCHID: 'c48a5d7388ef4d5d984dff6c6c117048',
  // SUBDOMAIN: 'hcpcs4',
  // SALESTATIONS: 's_official_website'
  // BASE_URL: 'http://hcpcs4.node244.com/api',
  // TENANTID: 'd43276732898f7c7610184b90330379c',
  // MERCHID: 'c48a5d7388ef4d5d984dff6c6c117048',
  // SUBDOMAIN: 'hcpcs4',
  // SALESTATIONS: 's_official_website'
}
